<script setup>
import { computed, onBeforeUnmount, provide, ref, watchEffect } from 'vue';
import { RouterView, useRoute } from 'vue-router';
import ContactModal from '@/components/layout/ContactModal.vue';
import PageLoader from '@/components/layout/PageLoader.vue';
import SiteFooter from '@/components/layout/SiteFooter.vue';
import SiteHeader from '@/components/layout/SiteHeader.vue';
import { usePageLoadProgress } from '@/composables/usePageLoadProgress.js';
import { useScrollActivity } from '@/composables/useScrollActivity.js';

const route = useRoute();
const contactOpen = ref(false);
const showFooter = computed(() => !route.meta.hideFooter);
const loading = ref(true);
const loaderFinished = ref(false);
const loaderRevealing = ref(false);
const { loadProgress, pageLoaded } = usePageLoadProgress();

const { isScrolling, release: releaseScrollActivity } = useScrollActivity();
provide('isScrolling', isScrolling);

function openContact() {
  contactOpen.value = true;
}

provide('openContact', openContact);
provide('pageLoading', loading);
provide('pageRevealing', loaderRevealing);

onBeforeUnmount(() => {
  releaseScrollActivity();
});

// 资源加载完成且聚集动画播完后再隐藏加载页
watchEffect(() => {
  if (pageLoaded.value && loaderFinished.value) {
    loading.value = false;
  }
});
</script>

<template>
  <div class="flex min-h-dvh flex-col">
    <!-- Logo 飞行时同步渐显首屏，避免加载层卸载后出现空白闪烁 -->
    <div
      class="flex min-h-dvh flex-col transition-opacity duration-500"
      :class="loading && !loaderRevealing ? 'pointer-events-none opacity-0' : 'opacity-100'"
      :aria-hidden="loading"
    >
      <SiteHeader />
      <main class="flex-1">
        <RouterView />
      </main>
      <SiteFooter v-if="!loading && showFooter" />
    </div>
    <ContactModal v-model="contactOpen" />
    <PageLoader
      v-if="loading"
      :load-progress="loadProgress"
      :page-loaded="pageLoaded"
      @revealing="loaderRevealing = true"
      @finished="loaderFinished = true"
    />
  </div>
</template>
